import reducer from './reducer'
import rootSaga from './sagas'

export const reducers = { googlePay: reducer }
export { rootSaga }
